document.addEventListener('DOMContentLoaded', function () {
  const facesBlock = document.querySelector('.dr-dual-block--faces');
  if (!facesBlock) return;

  const loadMoreButton = facesBlock.querySelector('[data-load-more-button]');
  const loadLessButton = facesBlock.querySelector('[data-load-less-button]');
  const hiddenItems = facesBlock.querySelectorAll('[data-load-more-item]');

  if (!loadMoreButton || !loadLessButton || !hiddenItems.length) return;

  loadMoreButton.addEventListener('click', function () {
    hiddenItems.forEach(function (item) {
      item.hidden = false;
      item.classList.remove('is-hidden');
    });

    loadMoreButton.hidden = true;
    loadLessButton.hidden = false;
  });

  loadLessButton.addEventListener('click', function () {
    hiddenItems.forEach(function (item) {
      item.hidden = true;
      item.classList.add('is-hidden');
    });

    loadLessButton.hidden = true;
    loadMoreButton.hidden = false;

    facesBlock.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});